module.exports = __webpack_public_path__ + "static/media/Snackss.f79ee4d0.JPG";